export default "__VITE_ASSET__CnCMo4Km__"